module.exports = __webpack_public_path__ + "img/17-02_Recognizing Talent and Potential.8859a6ee.svg";